import React from 'react';
import {UserScoreSchema} from "../../api";

type Props = {
    place: UserScoreSchema;
    score_only?: boolean;
};

export const Rating = ({place, score_only = false}: Props) => {
    const scores = (
        <>
            <div className='user-profile__info'>
                <div className='user-profile__stats'>
                    <div className='user-profile__stat'>
                        <span className='user-profile__stat-value'>#{place.position}</span>
                        <span className='user-profile__stat-label'>Место</span>
                    </div>
                    <div className='user-profile__stat'>
                        <span className='user-profile__stat-value'>{place.rating_score}</span>
                        <span className='user-profile__stat-label'>Рейтинг</span>
                    </div>
                    <div className='user-profile__stat'>
                        <span className='user-profile__stat-value'>{place.classic_points}</span>
                        <span className='user-profile__stat-label'>Матчи</span>
                    </div>
                    <div className='user-profile__stat'>
                        <span className='user-profile__stat-value'>{place.tournament_points}</span>
                        <span className='user-profile__stat-label'>Турнир</span>
                    </div>
                    <div className='user-profile__stat'>
                        <span className='user-profile__stat-value'>{place.total_score}</span>
                        <span className='user-profile__stat-label'>Всего</span>
                    </div>
                </div>

                <div className='user-profile__extra'>
                    {place.stake_profit !== 0 && (
                        <span
                            className={`user-profile__extra-item ${place.stake_profit! >= 0 ? 'user-profile__extra-item--positive' : 'user-profile__extra-item--negative'}`}>
                                            Ставки {place.stake_profit! >= 0 ? '+' : ''}{place.stake_profit}
                                        </span>
                    )}
                    {place.purchased_points! > 0 && (
                        <span className='user-profile__extra-item user-profile__extra-item--purchased'>
                                                Куплено +{place.purchased_points}
                                            </span>
                    )}
                </div>
            </div>
        </>
    );
    if (score_only) {
        return scores;
    }

    return (
        <>
            {
                place &&
                <div className='place'>
                    <h2>Статистика</h2>
                    {scores}
                </div>
            }
        </>
    );
};
